<template>
  <footer class="site-footer">
    <div class="container">

      <div class="row g-4">

        <!-- Brand -->
        <div class="col-lg-4 col-md-6">

          <div class="footer-brand">
            <div class="brand-icon">
              📚
            </div>

            <div>
              <h4>
                BookStore
              </h4>

              <p>
                Your digital destination
                for discovering, saving,
                and buying great books.
              </p>
            </div>
          </div>

          <div class="social-links">

            <a href="#" aria-label="Facebook">
              f
            </a>

            <a href="#" aria-label="Instagram">
              ◎
            </a>

            <a href="#" aria-label="LinkedIn">
              in
            </a>

            <a href="#" aria-label="Twitter">
              𝕏
            </a>

          </div>

        </div>

        <!-- Quick Links -->
        <div class="col-lg-2 col-md-6">

          <h6 class="footer-title">
            Quick Links
          </h6>

          <div class="footer-links">

            <router-link
              to="/books"
            >
              Books
            </router-link>

            <router-link
              v-if="isBuyer"
              to="/wishlist"
            >
              Wishlist
            </router-link>

            <router-link
              v-if="isBuyer"
              to="/cart"
            >
              Cart
            </router-link>

            <router-link
              v-if="isSeller"
              to="/books/add"
            >
              Add Book
            </router-link>

          </div>

        </div>

        <!-- Features -->
        <div class="col-lg-3 col-md-6">

          <h6 class="footer-title">
            Features
          </h6>

          <div class="footer-links">

            <span>
              🔎 Smart Search
            </span>

            <span>
              🏷️ Categories
            </span>

            <span>
              ❤️ Wishlist
            </span>

            <span>
              🛒 Shopping Cart
            </span>

          </div>

        </div>

        <!-- Contact -->
        <div class="col-lg-3 col-md-6">

          <h6 class="footer-title">
            Contact
          </h6>

          <div class="contact-info">

            <p>
              📧
              support@bookstore.com
            </p>

            <p>
              📞
              +20 100 000 0000
            </p>

            <p>
              📍
              Egypt
            </p>

          </div>

        </div>

      </div>

      <hr class="footer-divider">

      <div
        class="footer-bottom"
      >

        <p>
          © {{ currentYear }}
          BookStore.
          All rights reserved.
        </p>

        <p>
          Built with
          <span class="heart">
            
          </span>
          Vue.js
        </p>

      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  computed: {
    isBuyer() {
      return this.$store
        .getters.isBuyer
    },

    isSeller() {
      return this.$store
        .getters.isSeller
    },

    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.site-footer {
  margin-top:
    80px;

  padding:
    65px 0 22px;

  background:
    linear-gradient(
      135deg,
      #1c1230,
      #2b1455,
      #32164f
    );

  color:
    #ffffff;

  position:
    relative;

  overflow:
    hidden;
}

.site-footer::before {
  content:
    "";

  position:
    absolute;

  width:
    280px;

  height:
    280px;

  right:
    -100px;

  top:
    -120px;

  border-radius:
    50%;

  background:
    rgba(
      167,
      139,
      250,
      0.16
    );
}

.site-footer::after {
  content:
    "";

  position:
    absolute;

  width:
    220px;

  height:
    220px;

  left:
    -100px;

  bottom:
    -100px;

  border-radius:
    50%;

  background:
    rgba(
      236,
      72,
      153,
      0.08
    );
}

.footer-brand,
.footer-title,
.footer-links,
.contact-info,
.social-links,
.footer-divider,
.footer-bottom {
  position:
    relative;

  z-index:
    2;
}

.footer-brand {
  display:
    flex;

  gap:
    15px;

  align-items:
    flex-start;
}

.brand-icon {
  width:
    50px;

  height:
    50px;

  display:
    flex;

  justify-content:
    center;

  align-items:
    center;

  border-radius:
    14px;

  background:
    linear-gradient(
      135deg,
      #6c3bff,
      #ec4899
    );

  font-size:
    1.5rem;

  box-shadow:
    0 8px 20px
    rgba(
      108,
      59,
      255,
      0.3
    );
}

.footer-brand h4 {
  margin:
    0 0 8px;

  color:
    #ffffff;

  font-weight:
    800;
}

.footer-brand p {
  max-width:
    330px;

  margin:
    0;

  color:
    rgba(
      255,
      255,
      255,
      0.68
    );

  line-height:
    1.7;
}

.footer-title {
  margin-bottom:
    18px;

  color:
    #ffffff;

  font-size:
    0.82rem;

  letter-spacing:
    1.2px;

  text-transform:
    uppercase;
}

.footer-links {
  display:
    flex;

  flex-direction:
    column;

  gap:
    11px;
}

.footer-links a,
.footer-links span {
  color:
    rgba(
      255,
      255,
      255,
      0.67
    );

  text-decoration:
    none;

  font-size:
    0.9rem;

  transition:
    0.2s;
}

.footer-links a:hover {
  color:
    #c4b5fd;

  transform:
    translateX(4px);
}

.contact-info p {
  margin-bottom:
    11px;

  color:
    rgba(
      255,
      255,
      255,
      0.67
    );

  font-size:
    0.9rem;
}

.social-links {
  display:
    flex;

  gap:
    9px;

  margin-top:
    24px;
}

.social-links a {
  width:
    39px;

  height:
    39px;

  display:
    flex;

  justify-content:
    center;

  align-items:
    center;

  border-radius:
    50%;

  color:
    #ffffff;

  text-decoration:
    none;

  background:
    rgba(
      255,
      255,
      255,
      0.08
    );

  border:
    1px solid
    rgba(
      255,
      255,
      255,
      0.12
    );

  font-size:
    0.82rem;

  font-weight:
    700;
}

.social-links a:hover {
  background:
    #6c3bff;

  border-color:
    #6c3bff;

  transform:
    translateY(-3px);
}

.footer-divider {
  margin:
    40px 0 20px;

  border-color:
    rgba(
      255,
      255,
      255,
      0.12
    );
}

.footer-bottom {
  display:
    flex;

  justify-content:
    space-between;

  align-items:
    center;

  gap:
    15px;

  flex-wrap:
    wrap;
}

.footer-bottom p {
  margin:
    0;

  color:
    rgba(
      255,
      255,
      255,
      0.52
    );

  font-size:
    0.82rem;
}

.heart {
  color:
    #ec4899;
}

@media (max-width: 768px) {
  .site-footer {
    padding-top:
      45px;
  }

  .footer-bottom {
    flex-direction:
      column;

    align-items:
      flex-start;
  }
}
</style>